import { render, staticRenderFns } from "./IntroductionSection.vue?vue&type=template&id=4a21daca&"
import script from "./IntroductionSection.vue?vue&type=script&lang=js&"
export * from "./IntroductionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports